import { AppState } from '../index';

export const selectMarketAutoPlay = (state: AppState) => state.market.autoPlay;
export const selectMarketSales = (state: AppState) => state.market.sales;
export const selectMarketNfts = (state: AppState) => state.market.nfts;
